export class Power {
  constructor(
    public readonly name: string,
    public readonly summary?: string,
  ) { }
}
